import React, { useEffect, useState } from 'react';
import { api } from '../api/client';
import Spinner from './Spinner';
import { PRODUCT } from '../brand';

/**
 * Porte d'accès à l'interface interne. Elle ne s'affiche que si le serveur exige un
 * jeton (API_TOKEN renseigné) et que le navigateur n'en porte pas encore : sur un poste
 * isolé sans jeton, elle est invisible. Le jeton saisi est gardé dans ce navigateur et
 * présenté en en-tête à chaque appel (voir api/client.js) ; le serveur le pose aussi en
 * cookie, pour les navigateurs qui l'acceptent entre le domaine de l'interface et celui
 * de l'API. Les maquettes ouvertes dans des iframes et des onglets, elles, passent par
 * des adresses signées que l'API délivre à la demande.
 */
export default function AccessGate({ children }) {
  const [state, setState] = useState({ checked: false, allowed: false });
  const [token, setToken] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let active = true;
    api.authStatus()
      .then((s) => { if (active) setState({ checked: true, allowed: !s.required || s.authenticated }); })
      .catch(() => { if (active) setState({ checked: true, allowed: true }); }); // serveur muet : la page dira l'erreur
    const onUnauthorized = () => setState({ checked: true, allowed: false });
    window.addEventListener('reload:unauthorized', onUnauthorized);
    return () => { active = false; window.removeEventListener('reload:unauthorized', onUnauthorized); };
  }, []);

  if (!state.checked) return <div className="container"><Spinner label="Vérification de l'accès…" /></div>;
  if (state.allowed) return children;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await api.authLogin(token.trim());
      setToken('');
      setState({ checked: true, allowed: true });
    } catch (err) {
      setError(err.message || 'Jeton refusé.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="container access-gate">
      <form className="card access-gate-card" onSubmit={submit}>
        <h1>{PRODUCT.name}</h1>
        <p className="muted">Cet espace est réservé. Saisissez le jeton d'accès configuré sur le serveur (API_TOKEN).</p>
        <label htmlFor="access-token">Jeton d'accès</label>
        <input
          id="access-token"
          type="password"
          autoComplete="current-password"
          value={token}
          onChange={(e) => setToken(e.target.value)}
          required
          autoFocus
        />
        {error && <p className="error" role="alert">{error}</p>}
        <button type="submit" className="btn" disabled={busy || !token.trim()}>
          {busy ? 'Vérification…' : 'Entrer'}
        </button>
      </form>
    </div>
  );
}
